import axios from 'axios'
import { createCollection } from './collection'

const API_URL = process.env.API_URL

export default createCollection({
  fetchAll: {
    request: () => axios.get(API_URL + '/reports'),
    processResponse (response) {
      return response.data.data.reduce((collection, item) => {
        collection.ids.push(item.id)
        collection.entities[item.id] = item
        return collection
      }, { ids: [], entities: {}, loaded: true })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/modules/abuseReports.js